import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";
import SubText from "components/shared/SubText";
import CreatorVideoSkeleton from "components/skeleton/CreatorVideoSkeleton";
import { RouteName } from "constant/routeNames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreatorService from "services/creators/CreatorService";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

const VideohomeCreatorCard = lazy(
  () => import("pages/BecomeACreator/shared/VideohomeCreatorCard"),
);

const WelcomePageCreatorVideoSection = () => {
  const [randomVideos, setRandomVideos] = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    setIsLoading(true);
    CreatorService.getArtistCreatorsRandomVideo()
      .then((res) => {
        setIsLoading(false);
        setRandomVideos(res.data);
        // console.log("randomVideos", res.data);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  }, []);

  return (
    <div>
      {!isLoading && (
        <>
          <ErrorBoundary>
            <Suspense fallback={<CreatorVideoSkeleton />}>
              <div className="flex mt-10 justify-between w-[95%] max-sm:w-full  ">
                {randomVideos && randomVideos?.length > 0 && (
                  <>
                    <SectionHeading
                      text="Creator Videos"
                      className="font-bold max-sm:ml-4"
                    />
                    <Link to={RouteName.SeeAllCreatorsVideosRoute}>
                      <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                        See all
                        <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                          →
                        </span>
                      </p>
                    </Link>
                  </>
                )}
              </div>

              <div className="mx-auto">
                <Swiper
                  slidesPerView={6}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    350: {
                      slidesPerView: 1,
                    },
                    500: {
                      slidesPerView: 3,
                    },
                    1100: {
                      slidesPerView: 3,
                    },
                    1300: {
                      slidesPerView: 4,
                    },
                    1500: {
                      slidesPerView: 4,
                    },
                    1700: {
                      slidesPerView: 5,
                    },
                  }}
                  modules={[Pagination, Navigation]}
                  navigation={true}
                  className="w-full mx-auto mt-5 mb-5 mySwiper"
                >
                  {randomVideos &&
                    randomVideos?.map((video: any, i) => (
                      <SwiperSlide key={i}>
                        <div className="flex w-full gap-10 mx-auto">
                          <VideohomeCreatorCard
                            video={video}
                            slug={video?.creator?.slug}
                            isLoading={isLoading}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </Suspense>
          </ErrorBoundary>
        </>
      )}
      {isLoading && <CreatorVideoSkeleton />}
    </div>
  );
};

export default WelcomePageCreatorVideoSection;
